import { Link } from 'react-router-dom';
import { Award, Heart, Shield, Target, Users, Zap } from 'lucide-react';
import ServiceCard from './ServiceCard';

const DisciplinesSection = () => (
  <section id="disciplinas" className="py-32">
    <div className="container mx-auto px-6">
      <div className="mb-20 max-w-2xl">
        <h2 className="mb-4 text-xs font-bold uppercase tracking-[0.5em] text-emerald-600">
          Cuerpo y Disciplina
        </h2>
        <h3 className="mb-8 text-5xl font-black leading-tight text-slate-900">
          Formación Marcial en <br /> Gran Canaria
        </h3>
        <p className="text-lg leading-relaxed text-slate-600">
          Programas para fortalecer el cuerpo y templar el espíritu bajo la dirección de Richard Atik, en la línea
          del Gran Maestro Masaaki Hatsumi y del Maestro Pedro Fleitas.
        </p>
        <p className="mt-6">
          <Link
            to="/artes-marciales"
            className="text-sm font-bold uppercase tracking-widest text-emerald-700 underline-offset-4 hover:underline"
          >
            Bujinkan, linaje y Unryūkai — ver página ampliada
          </Link>
        </p>
      </div>

      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        <ServiceCard
          category="Marcial"
          title="Bujinkan Unryukai Budo Taijutsu"
          icon={Award}
          description="Budō Taijutsu y tradición de nueve escuelas. Práctica sin enfoque competitivo deportivo, orientada al desarrollo personal y a la defensa real."
          details={
            <>
              <p>
                Se trabaja taijutsu, armas tradicionales y cultura marcial en un ambiente respetuoso, sin competición
                deportiva.
              </p>
              <p>
                La línea formativa se inspira en el legado de Masaaki Hatsumi y en la transmisión en España vía Pedro
                Fleitas (Unryūkai). Para linaje, historia y matices del programa visita la página ampliada de Bujinkan.
              </p>
            </>
          }
        />
        <ServiceCard
          category="Salud"
          title="Chi Kung (Qi Gong)"
          icon={Zap}
          description="Movimientos que armonizan cuerpo, mente y emociones, coordinados con la respiración y la focalización. Aptos para distintos niveles y orientados a la paz interior."
          details={
            <>
              <p>Las secuencias se adaptan al grupo; no hace falta experiencia previa para empezar.</p>
              <p>
                Se prioriza la respiración consciente, la suavidad del movimiento y la regulación del sistema nervioso.
              </p>
            </>
          }
        />
        <ServiceCard
          category="Bienestar"
          title="Yoga"
          icon={Heart}
          description="Filosofía de vida con posturas, respiración, relajación y meditación para reforzar el equilibrio cuerpo–mente."
          details={
            <>
              <p>Integra posturas (asanas), trabajo respiratorio y espacios de silencio o meditación.</p>
              <p>La propuesta busca un equilibrio integral: fuerza, flexibilidad y claridad mental.</p>
            </>
          }
        />
        <ServiceCard
          category="Seguridad"
          title="Protección personal para mujeres (Yosei Goshinjutsu)"
          icon={Users}
          description="Clases específicas para mujeres jóvenes y adultas: autoprotección cuerpo a cuerpo y con objetos cotidianos (bolso, llaves, móvil, etc.), con instructora."
          details={
            <>
              <p>Enfoque y calendario pensados para el público femenino, con acompañamiento en grupo.</p>
              <p>
                Se practican respuestas realistas usando el cuerpo y objetos habituales (bolso, llaves, móvil), sin
                dramatizar y con foco en la decisión y la salida segura.
              </p>
            </>
          }
        />
        <ServiceCard
          category="Seguridad"
          title="Defensa personal"
          icon={Target}
          description="Técnicas realistas para la autoprotección en situaciones de riesgo cotidiano."
          details={
            <>
              <p>Se trabajan escenarios cotidianos: espacios cerrados, calle, desplazamientos y entornos urbanos.</p>
              <p>Énfasis en prevención, verbalización y abandono seguro del conflicto cuando sea posible.</p>
            </>
          }
        />
        <ServiceCard
          category="Profesional"
          title="Seguridad privada"
          icon={Shield}
          description="Formación para empresas de seguridad privada y cuerpos de seguridad del Estado."
          details={
            <>
              <p>
                Contenidos orientados a la normativa aplicable y a las competencias exigidas en el ámbito profesional.
              </p>
              <p>
                Posibilidad de adaptar bloques formativos según colectivo (empresas de seguridad, equipos operativos,
                etc.). Consulta disponibilidad y modalidad por teléfono o WhatsApp.
              </p>
            </>
          }
        />
      </div>
    </div>
  </section>
);

export default DisciplinesSection;
